var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container container_40 orders" }, [
    _c("div", { staticClass: "text_large" }, [
      _vm._v(_vm._s(_vm.i18n.trd_orders()))
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "orders__list-wrap" },
      [
        _c("order-list", {
          staticClass: "orders__list",
          attrs: { type: _vm.ORDER_TYPES.buy, list: _vm.formattedBuyOffers }
        }),
        _vm._v(" "),
        _c("order-list", {
          staticClass: "orders__list",
          attrs: { type: _vm.ORDER_TYPES.sell, list: _vm.formattedSellOffers }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-05c92710", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05c92710","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/trade/index/components/orders/Trade.Orders.vue
// module id = ocR8
// module chunks = 1